import { ReactElement } from 'react';
import NewButton from './NewButton';
import { Typography } from 'antd';
import { styled } from 'styled-components';
import { blockStyle } from '../../../../components/styles/Block';

export const HeaderBlock = styled.header`
  ${blockStyle}
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const { Title } = Typography;

interface Props {
  title: string;
}

const Header = ({ title }: Props): ReactElement => (
  <HeaderBlock>
    <Title level={4}>{title}</Title>
    <NewButton />
  </HeaderBlock>
);

export default Header;
